// extracted by mini-css-extract-plugin
module.exports =  {"root":"TkNy18okygagk63qUn7p","instagramIndicator":"XsbHBzGjAmvG_25gY_dJ"};